
import "./App.css";


const News = () => {
  return (
    <div>
      <h4>
        Раздел находится в разработке! Если у вас есть готовые статьи, присылайте нам по{" "}
        <a href="mailto:omakeykina@gmail.com">почте</a>, и мы разместим их с указанием автора!
      </h4>
      <h4>Мы открыты для любых ваших идей и предложений!</h4>
    </div>
  );
};

export default News;